module.exports = __webpack_public_path__ + "static/media/down_to_dakar_mototurismo_1.0f618cda.jpg";